export var isCorrectPhoneObject = function isCorrectPhoneObject(phone) {
  return !!(phone && phone.countryCode && phone.code && phone.number);
};